module.exports = __webpack_public_path__ + "static/easycourse_logo_white-312c62619192657551493e7512bbf614.png";